import angular from 'angular';

import toastr from 'angular-toastr';
import LogsGrid from '../../cmsCore/LogsModules/LogsGrid/LogsGrid';

let logsPageDirective = angular.module('cms.pages.logs.directive', [LogsGrid, toastr])
    .component('appLogs', {
        template: require('./logs.html'),
        bindings: {
            $transition$: '<'
        },
        controller: function ($http, LogResource, GridParamsConverter, $state, toastr, gettextCatalog) {
            /** @ngInject */

            this.$onInit = () => {
                this.initialParams = this.$transition$.params();
            };

            this.clearLogs = () => {
                LogResource.deleteOld('',
                    response => {
                        toastr.success(
                            gettextCatalog.getString('Logs cleared in database!'),
                            gettextCatalog.getString('Success')
                        );
                    }
                );
            };

            this.onParamsChange = params => {
                delete params.page;
                $state.go('.', params, {
                    location: 'replace'
                });
            };

            this.onPageChange = page => {
                if(page === 0) {
                    return;
                }
                $state.go('.', {page:  page !== 1 ? page : undefined}, {
                    location: 'replace'
                });
            };

        }
    });

export default logsPageDirective.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Logs/LogsPageDirective.js